module.exports = __webpack_public_path__ + "static/img/9.efacfd5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/eng/9.png
// module id = JjRJ
// module chunks = 0